export interface ValidacaoResult {
    valid: boolean;
    error?: string;
}

export interface ValidacaoCamposResult {
    valid: boolean;
    errors: Record<string, string>;
}

export const validateCep = (cep: string): boolean => {
    if (!cep) return false;
    const numbers = cep.replace(/\D/g, '');
    return numbers.length === 8;
};

export const validateProcesso = (processo: string): boolean => {
    if (!processo) return false;
    const numbers = processo.replace(/\D/g, '');
    return numbers.length === 20;
};

export const validateRequired = (value: any): boolean => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (typeof value === 'number') return !isNaN(value);
    if (Array.isArray(value)) return value.length > 0;
    return true;
};

export const validatePrazoFatal = (
    data: Date | string | null | undefined,
    prazoAceite: Date | string | null | undefined,
    prazoConclusao: Date | string | null | undefined
): ValidacaoResult => {
    if (!data) {
        return { valid: false, error: 'Prazo fatal é obrigatório' };
    }

    const dataPrazoFatal = data instanceof Date ? data : new Date(data);
    if (isNaN(dataPrazoFatal.getTime())) {
        return { valid: false, error: 'Data do prazo fatal inválida' };
    }

    const horas = dataPrazoFatal.getHours();
    const minutos = dataPrazoFatal.getMinutes();
    const segundos = dataPrazoFatal.getSeconds();
    const milissegundos = dataPrazoFatal.getMilliseconds();
    
    if (horas === 0 && minutos === 0 && segundos === 0 && milissegundos === 0) {
        return { valid: false, error: 'Data e hora fatal são obrigatórias' };
    }

    if (prazoAceite) {
        const dataPrazoAceite = prazoAceite instanceof Date ? prazoAceite : new Date(prazoAceite);
        if (!isNaN(dataPrazoAceite.getTime()) && dataPrazoFatal < dataPrazoAceite) {
            return { valid: false, error: 'Prazo fatal deve ser posterior ao prazo de aceite' };
        }
    }

    if (prazoConclusao) {
        const dataPrazoConclusao = prazoConclusao instanceof Date ? prazoConclusao : new Date(prazoConclusao);
        if (!isNaN(dataPrazoConclusao.getTime()) && dataPrazoFatal > dataPrazoConclusao) {
            return { valid: false, error: 'Prazo fatal deve ser anterior ao prazo de conclusão' };
        }
    }

    return { valid: true };
};

export const validateAllFields = (
    fields: Record<string, any>,
    requiredFields: string[]
): ValidacaoCamposResult => {
    const errors: Record<string, string> = {};
    let isValid = true;

    for (const field of requiredFields) {
        const value = fields[field];
        
        if (!validateRequired(value)) {
            errors[field] = 'Este campo é obrigatório';
            isValid = false;
        }
    }

    if (fields.cep && !validateCep(fields.cep)) {
        errors.cep = 'CEP deve ter 8 dígitos';
        isValid = false;
    }

    if (fields.numero_processo && fields.natureza === 'Judicial' && !validateProcesso(fields.numero_processo)) {
        errors.numero_processo = 'Número do processo deve ter 20 dígitos no formato CNJ';
        isValid = false;
    }

    return { valid: isValid, errors };
};


